import { makeStyles } from "@material-ui/core";
import { FC } from "react";
import { TheCycleverseTheme } from "src/theme";
import { InputComponent, SelectorComponent, SmallInputComponent } from "../CalculatorSelectInput";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  inputContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  inputStyles: {
    margin: "0px 10px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },

  inputUnit: {
    fontWeight: "bold",
    fontSize: "16px",
    marginRight: "10px",
    width: "35px",
    marginTop: "-25px",
  },
}));

export const InputWithLabelAtTheBottom: FC<{
  label: string;
  onChange: Function;
  name: string;
  value: string | number;
  isSelect?: boolean;
  isNotSmall?: boolean;
  inputUnite?: string;
  disabled?: boolean;
}> = ({
  label,
  onChange,
  name,
  value,
  isSelect = false,
  children,
  isNotSmall = false,
  inputUnite,
  disabled = false,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.inputContainer}>
      <div className={classes.inputStyles}>
        {isSelect ? (
          <SelectorComponent onChange={() => onChange()} name={name || ""} value={value || ""}>
            {children}
          </SelectorComponent>
        ) : isNotSmall ? (
          <InputComponent onChange={onChange} name={name || ""} result="" value={value || ""} />
        ) : (
          <SmallInputComponent
            disabled={disabled}
            onChange={(e) => onChange(e)}
            name={name || ""}
            result=""
            value={value || ""}
          />
        )}
        <div style={{ fontWeight: "bold", marginTop: "3px", textAlign: "center" }}>{label}</div>
      </div>
      {inputUnite ? <div className={classes.inputUnit}>{inputUnite && inputUnite}</div> : null}
    </div>
  );
};
